// assets
import {
    DisplaySettings
} from '@mui/icons-material';

import { ManageFundersIcon } from 'components/icons/sidebarIcons';

// constant
export const icons = {
    DisplaySettings
};

const manageFundersv2 = {
    id: 'manage-funders',
    title: 'side_menu.manage_funders',
    type: 'group',
    roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
    icon: 'DisplaySettings', //icons.DisplaySettings,
    collapse: false,
    url: 'manage-funders',
};

export default manageFundersv2;
